export default __webpack_public_path__ + "images/cca0e3a9fd5d95dc7909222ea71f2f3a.png";